import React from "react";
import "./NoPermissionView.css";
export var NoPermissionView = function () {
    return (React.createElement("div", { className: "container" },
        React.createElement("img", { src: "https://storage.googleapis.com/tenderd-ui/assets/undraw_secure_files_re_6vdh.svg", alt: "No Permission" }),
        React.createElement("span", null, "You do not have permission to access this area")));
};
